import isObject from 'lodash/isObject';
import uniqueId from 'lodash/uniqueId';
import propTypes from 'prop-types';
import React from 'react';

const MultipleTransactionDetails = ({ selectedPrints }) => {
	const idPrefix = uniqueId();

	return (
		<div className="body">
			{selectedPrints
				.map(({ printDetails }) => {
					const { toAddress, netstampSummary, printTypeId } = isObject(
						printDetails
					)
						? printDetails
						: {};

					// NetStamps print record
					if (printTypeId === 5) {
						return netstampSummary;
					} else if (isObject(toAddress)) {
						return toAddress.name || toAddress.companyName;
					}

					return null;
				})
				.filter(str => str) // remove empty string or undefined element
				.map((summary, index) => (
					<p key={`${idPrefix}_${index}`}>{summary}</p>
				))}
		</div>
	);
};

MultipleTransactionDetails.propTypes = {
	selectedPrints: propTypes.array.isRequired,
};

export default MultipleTransactionDetails;
